import { Vue, i18n } from "Components/vue";
import "../parts/catalog";

const catFilterElem = document.querySelector("#categoriesFilter");

if (catFilterElem) {
    const productsCategories = catFilterElem.dataset.categories;
    const selectedCategoryId = catFilterElem.dataset.selected;
    const filterType = catFilterElem.dataset.filterType;
    const rootCategories = JSON.parse(catFilterElem.dataset.rootCategories);

    new Vue({
        i18n,
        el: "#categoriesFilter",
        components: {
            CategoriesFilter: () => import("VueComponents/CategoriesFilter.vue"),
        },
        template: `<CategoriesFilter :select-category-id="${
            selectedCategoryId || null
        }" :visible-categories="${
            rootCategories.length
        }" :products-categories="${productsCategories}" :filter-type="${filterType}"></CategoriesFilter>`,
    });
}

rEvent.on("Listing.fetchedData", () => {
    tippy(".js-tippy-white", {
        arrow: true,
        theme: "white",
        performance: true,
        interactive: true,
        maxWidth: "600px",
    });

    tippy(".js-thumb-action-tippy", {
        arrow: true,
        animation: "shift-away",
        placement: "right",
        theme: "thumb-action",
        duration: [300, 180],
        inertia: true,
    });

    tippy(".js-thumb-badge-tippy", {
        arrow: true,
        animation: "shift-away",
        placement: "top",
        theme: "thumb-badge",
        duration: [300, 180],
        inertia: true,
        maxWidth: "220px",
    });
});
